
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class HistoryNoResults extends Vue {
  @Prop({ default: true }) showButton!: boolean;

  @Prop({ default: false }) isLoading!: boolean;

  @Prop({ default: false }) redirectToHistory!: boolean;
}
